import { useCustomQuery } from "@/shared/hooks/useCustomQuery";
import CategoryService from "@/features/categories/service/categoryService";

export const useCategoriesData = ({ 
    type = "", 
    page = 1, 
    limit = 10 
}: { 
    type?: "PRESET" | "LEARNING" | ""; 
    page?: number; 
    limit?: number; 
}) => {
    
    return useCustomQuery({
        serviceInstance: CategoryService.Instance,
        selectAction: (service) => service.getCategories,
        parameter: { type, page, limit },
        options: {
            staleTime: 1 * 60 * 1000, // 1 minuto
        },
    });
};

export const useCategoryData = (id: string) => {
    return useCustomQuery({
        serviceInstance: CategoryService.Instance,
        selectAction: (service) => service.getCategoryById,
        parameter: { id },
        options: {
            enabled: !!id,
            staleTime: 5 * 60 * 1000,
        },
    });
};